<mat-progress-bar
  mode="indeterminate"
  color="warn"
  [style.display]="loading ? 'block' : 'none'"
/>

<h2 class="m-4"><span class="titulo">Botones </span></h2>

<div class="table-container mat-elevation-z2">
  <!-- Filtro y columnas -->
  <div class="row justify-between align-center" style="padding: 1em">
    <!-- Filtros -->
    <app-filtro-tabla
      class="flex-1"
      [search]="search"
      [datos]="[notificacion]"
      (onFilterChange)="cambioFiltro($event)"
    />
    <!-- Columnas -->
    <app-column-select
      [(columns)]="columnas"
      [columnNames]="nombreColumnas"
      [saveName]="saveColumnas"
    />
    <!-- Boton Crear -->
    <button mat-fab matTooltip="Crear" color="primary" [routerLink]="'crear'">
      <mat-icon>add</mat-icon>
    </button>
  </div>

  <mat-paginator
    [length]="totalCount"
    [pageSize]="helper.pageSize"
    [pageSizeOptions]="helper.pageSizeOptions"
    [showFirstLastButtons]="true"
    (page)="pageEvent($event)"
  />

  <!-- Tabla -->
  <mat-table
    class="responsive"
    [dataSource]="dataSource"
    matSort
    (matSortChange)="sortChange($event)"
  >
    <!-- Columna nombre  -->
    <ng-container matColumnDef="nombre">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Nombre
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Nombre:</span>
        {{ row.nombre }}
      </mat-cell>
    </ng-container>

    <!-- Columna variante  -->
    <ng-container matColumnDef="variante">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Variante
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Variante:</span>
        {{ row.variante }}
      </mat-cell>
    </ng-container>

    <!-- Columna funcion  -->
    <ng-container matColumnDef="funcion">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Función
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Función:</span>
        {{ row.funcion }}
      </mat-cell>
    </ng-container>

    <!-- Columna texto  -->
    <ng-container matColumnDef="texto">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Texto
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Texto:</span>
        {{ row.texto }}
      </mat-cell>
    </ng-container>

    <!-- Columna color  -->
    <ng-container matColumnDef="color">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Color
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Color:</span>
        {{ row.color }}
      </mat-cell>
    </ng-container>

    <!-- Columna imagen -->
    <ng-container matColumnDef="imagen">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Imagen
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Imagen:</span>

        @if (row.urlImagen) {
          <img
            #img
            class="boton"
            [src]="row.urlImagen"
            alt="imagen"
            (mousedown)="img.src = row.urlImagenPush"
            (mouseup)="img.src = row.urlImagen"
            (mouseleave)="img.src = row.urlImagen"
          />
        }

        @if (!row.urlImagen && row.texto) {
          <button
            mat-raised-button
            [style.background]="row.color"
            [style.color]="helper.invertColor(row.color)"
          >
            {{ row.texto }}
          </button>
        }
      </mat-cell>
    </ng-container>

    <!-- Columna global  -->
    <ng-container matColumnDef="global">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Global
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Global:</span>
        @if (row.global) {
          <mat-icon [style.color]="'green'">check</mat-icon>
        }
        @if (!row.global) {
          <mat-icon [style.color]="'red'">clear</mat-icon>
        }
      </mat-cell>
    </ng-container>

    <!-- Columna prioridad  -->
    <ng-container matColumnDef="prioridad">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Prioridad
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Global:</span>
        @if (row.prioridad) {
          {{ row.prioridad }}
        } @else {
          <span class="no-info">Sin Prioridad</span>
        }
      </mat-cell>
    </ng-container>

    <!-- Columna sirena  -->
    <ng-container matColumnDef="sirena">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Sirena
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Sirena:</span>
        @if (row.sirena) {
          <mat-icon [style.color]="'green'">check</mat-icon>
        }
        @if (!row.sirena) {
          <mat-icon [style.color]="'red'">clear</mat-icon>
        }
      </mat-cell>
    </ng-container>

    <!-- Columna notificacion  -->
    <ng-container matColumnDef="notificacion">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Notificación
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Notificación:</span>
        @if (row.notificacion) {
          {{ row.notificacion }}
        } @else {
          <span class="no-info">Sin Notificación</span>
        }
      </mat-cell>
    </ng-container>

    <!-- Columna Seguimiento Automático -->
    <ng-container matColumnDef="seguimiento">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Seguimiento Automático </mat-header-cell
      >>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Seguimiento:</span>
        <!-- Si tiene trackeo -->
        @if (row.trackeo?.gps || row.trackeo?.audio || row.trackeo?.foto) {
          <div class="p-2">
            <!-- <p class="m-0">Tiempo: {{ row.trackeo.tiempoMinutos }} min.</p>
              <p class="m-0">Intervalo: {{ row.trackeo.intervaloSegundos }} seg.</p> -->
            <div class="segmento">
              @if (row.trackeo?.gps) {
                <p class="m-0">GPS</p>
              }
              @if (row.trackeo?.gpsIntervalo) {
                <p class="texto-chico">
                  Intervalo: {{ row.trackeo?.gpsIntervalo }} seg.
                </p>
              }
              @if (row.trackeo?.gpsTiempo) {
                <p class="texto-chico">
                  Duración: {{ row.trackeo?.gpsTiempo }} minutos.
                </p>
              }
            </div>
            <div class="segmento">
              @if (row.trackeo?.audio) {
                <p class="m-0">Audio</p>
              }
              @if (row.trackeo?.audioTiempo) {
                <p class="texto-chico">
                  Duración: {{ row.trackeo?.audioTiempo }} minutos.
                </p>
              }
            </div>
            <div class="segmento">
              @if (row.trackeo?.foto) {
                <p class="m-0">Foto</p>
              }
              @if (row.trackeo?.fotoCantidad) {
                <p class="texto-chico">
                  Cantidad: {{ row.trackeo?.fotoCantidad }}
                </p>
              }
              @if (row.trackeo?.fotoIntervalo) {
                <p class="texto-chico">
                  Intervalo: {{ row.trackeo?.fotoIntervalo }} seg.
                </p>
              }
            </div>
          </div>
        }
        <!-- Si no tiene trackeo -->
        @if (!row.trackeo?.gps && !row.trackeo?.auido && !row.trackeo?.foto) {
          <div>
            <mat-icon>clear</mat-icon>
          </div>
        }
      </mat-cell>
    </ng-container>

    <!-- Columna Seguimiento Manual -->
    <ng-container matColumnDef="seguimientoManual">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Seguimiento Manual </mat-header-cell
      >>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Seguimiento:</span>
        <!-- Si tiene trackeo -->
        @if (
          row.envioMultimedia?.gps ||
          row.envioMultimedia?.audio ||
          row.envioMultimedia?.foto
        ) {
          <div class="p-2 segmento">
            @if (row.envioMultimedia?.gps) {
              <p class="m-0">GPS</p>
            }
            @if (row.envioMultimedia?.audio) {
              <p class="m-0">Audio</p>
            }
            @if (row.envioMultimedia?.foto) {
              <p class="m-0">Foto</p>
            }
          </div>
        } @else {
          <div>
            <mat-icon>clear</mat-icon>
          </div>
        }
      </mat-cell>
    </ng-container>

    <!-- Columna Acciones -->
    <ng-container matColumnDef="acciones">
      <mat-header-cell *matHeaderCellDef> Acciones </mat-header-cell>>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Acciones:</span>
        <div>
          @if (row.editable) {
            <button
              class="mx-1 no-shadow"
              mat-mini-fab
              color="primary"
              matTooltip="Clonar"
              (click)="clonar(row)"
            >
              <mat-icon>content_copy</mat-icon>
            </button>
          }

          <button
            class="mx-1 no-shadow"
            mat-mini-fab
            color="accent"
            matTooltip="Editar"
            [routerLink]="['editar', row._id]"
          >
            <mat-icon>edit</mat-icon>
          </button>
          @if (row.editable) {
            <button
              class="mx-1 no-shadow"
              mat-mini-fab
              color="warn"
              matTooltip="Eliminar"
              (click)="eliminar(row)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          }
        </div>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="columnas; sticky: true" />
    <mat-row *matRowDef="let row; columns: columnas" />
  </mat-table>
</div>
